import React from "react";

// import data from "./data"
import FeatureCard from "./featureCard";
import "./style.scss";

const FeatureCards = ({ data, parentCategory, blockMode }) => (
  <div className="accounts-row__wrap">
    <div className="accounts-row accounts-row--three-items filter-list">
      {data.map((item) => (
        <FeatureCard
          {...item}
          parentCategory={parentCategory}
          blockMode={blockMode}
        />
      ))}
    </div>
  </div>
);

export default FeatureCards;
